import React from 'react';
import { Box } from '@mui/material';
import ProjectFileListContainer from '../../../containers/techmng/files/ProjectFileListContainer';
import ProjectMultiFileFormContainer from '../../../containers/techmng/files/ProjectMultiFileFormContainer';


const ProjectFileTemplate = () => {
  return (
    <Box
      sx={{
        mt: 2,
      }}
    >
      <ProjectFileListContainer />
      <ProjectMultiFileFormContainer />
    </Box>
  );
};

export default ProjectFileTemplate;
